export var PdfViewerEventType;
(function (PdfViewerEventType) {
    PdfViewerEventType["FocusChange"] = "[showpad-pdf-viewer] Focus Change";
    PdfViewerEventType["PageRendered"] = "[showpad-pdf-viewer] Page Rendered";
    PdfViewerEventType["RenderedPageFocus"] = "[showpad-pdf-viewer] Rendered Page Focus";
    PdfViewerEventType["NavigateToPage"] = "[showpad-pdf-viewer] Navigate To Page";
    PdfViewerEventType["NavigateToPageNumber"] = "[showpad-pdf-viewer] Navigate To Page Number";
    PdfViewerEventType["PageSelected"] = "[showpad-pdf-viewer] Page Selected";
    PdfViewerEventType["SwitchLayout"] = "[showpad-pdf-viewer] Switch Layout";
    PdfViewerEventType["ZoomIn"] = "[showpad-pdf-viewer] ZoomIn";
    PdfViewerEventType["ZoomOut"] = "[showpad-pdf-viewer] ZoomOut";
    PdfViewerEventType["PreviewRendered"] = "[showpad-pdf-viewer] Preview Rendered";
    PdfViewerEventType["RenderedPreviewFocus"] = "[showpad-pdf-viewer] Rendered Preview Focus";
    PdfViewerEventType["RenderFailed"] = "[showpad-pdf-viewer] Render Failed";
    PdfViewerEventType["SelectPage"] = "[showpad-pdf-viewer] Select Page";
    PdfViewerEventType["DeselectPage"] = "[showpad-pdf-viewer] Deselect Page";
    PdfViewerEventType["DownloadAsset"] = "[showpad-pdf-viewer] Download Asset";
    PdfViewerEventType["ThumbnailsOpenedChange"] = "[showpad-pdf-viewer] Thumbnails Opened Change";
    PdfViewerEventType["SearchIsAvailable"] = "[showpad-pdf-viewer] Search is available";
    PdfViewerEventType["SearchIsUnavailable"] = "[showpad-pdf-viewer] Search is unavailable";
    PdfViewerEventType["ToggleSearch"] = "[showpad-pdf-viewer] Show/hide search";
    PdfViewerEventType["GoToNextSearchResultPage"] = "[showpad-pdf-viewer] Go To Next Search Result Page";
    PdfViewerEventType["GoToPreviousSearchResultPage"] = "[showpad-pdf-viewer] Go To Previous Search Result Page";
    PdfViewerEventType["InitializeSearch"] = "[showpad-pdf-viewer] Initialize search";
    PdfViewerEventType["FetchSearchResults"] = "[showpad-pdf-viewer] Fetch search results";
    PdfViewerEventType["ToggleThumbnails"] = "[showpad-pdf-viewer] Toggle Thumbnails";
})(PdfViewerEventType || (PdfViewerEventType = {}));
export class PdfViewerFocusChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.FocusChange;
    }
}
export class PdfViewerPageRenderedEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.PageRendered;
    }
}
export class PdfViewerRenderedPageFocusEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.RenderedPageFocus;
    }
}
export class PdfViewerNavigateToPageEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.NavigateToPage;
    }
}
export class PdfViewerNavigateToPageNumberEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.NavigateToPageNumber;
    }
}
export class PdfViewerPageSelectedEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.PageSelected;
    }
}
export class PdfViewerSwitchLayoutEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.SwitchLayout;
    }
}
export class PdfViewerZoomInEvent {
    constructor(payload = null) {
        this.payload = payload;
        this.type = PdfViewerEventType.ZoomIn;
    }
}
export class PdfViewerZoomOutEvent {
    constructor(payload = null) {
        this.payload = payload;
        this.type = PdfViewerEventType.ZoomOut;
    }
}
export class PdfViewerPreviewRenderedEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.PreviewRendered;
    }
}
export class PdfViewerRenderedPreviewFocusEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.RenderedPreviewFocus;
    }
}
export class PdfViewerRenderFailedEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.RenderFailed;
    }
}
export class PdfViewerSelectPageEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.SelectPage;
    }
}
export class PdfViewerDeselectPageEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.DeselectPage;
    }
}
export class PdfViewerDownloadAssetEvent {
    constructor(payload = null) {
        this.payload = payload;
        this.type = PdfViewerEventType.DownloadAsset;
    }
}
export class PdfViewerThumbnailsOpenedChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.ThumbnailsOpenedChange;
    }
}
export class PdfViewerToggleThumbnails {
    constructor() {
        this.type = PdfViewerEventType.ToggleThumbnails;
    }
}
export class PdfViewerSearchIsAvailableEvent {
    constructor() {
        this.type = PdfViewerEventType.SearchIsAvailable;
    }
}
export class PdfViewerSearchIsUnavailableEvent {
    constructor() {
        this.type = PdfViewerEventType.SearchIsUnavailable;
    }
}
export class PdfViewerGoToNextSearchResultPageEvent {
    constructor() {
        this.type = PdfViewerEventType.GoToNextSearchResultPage;
    }
}
export class PdfViewerGoToPreviousSearchResultPageEvent {
    constructor() {
        this.type = PdfViewerEventType.GoToPreviousSearchResultPage;
    }
}
export class PdfViewerInitializeSearchEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.InitializeSearch;
    }
}
export class PdfViewerFetchSearchResultsEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerEventType.FetchSearchResults;
    }
}
export class PdfViewerToggleSearchEvent {
    constructor() {
        this.type = PdfViewerEventType.ToggleSearch;
    }
}
//# sourceMappingURL=pdf-viewer-event.type.js.map